export default "__VITE_ASSET__D_Ism_k8__ 400w, __VITE_ASSET__CPLjmZd$__ 800w, __VITE_ASSET__CgOQ3uZC__ 1200w";